export default __webpack_public_path__ + "static/media/skovstykket-townhouse-4-rooms-04.9fce56fc.jpg";